module.exports = __webpack_public_path__ + "static/images/top-img.ba17fa2.png";